import React from 'react';
import Modal from '../../../../components/Modal/Modal';
import RequestExist from '@/presentation/modules/procedures/components/Modals/RequestExists';
import Spinner from '../../../../../../components/Spinner';
import { Block, Heading } from '../../../../../../components';
import { BackButton } from '../../../../components';
import ConfirmationQuit from './components/Messages/ConfirmationQuit';
import RegisterForm from './components/RegisterForm';
import Processing from '@/presentation/components/Processing';
import {
  ContainerProcedure,
  SubContainer
} from '../../../certificates-constancies/type1/info/components';
import {
  TextTitle,
  ToggleHeader
} from '../../../certificates-constancies/type1/register/components';
import Step from '../../UpdatePhoto/Register/components/Step';
import NotAvailable from '@/presentation/modules/procedures/components/Modals/NotAvailable';

interface RetirementOfPeriodRegisterViewProps {
  procedureSelectedInfo: any;
  isLoading: boolean;
  handleSubmit: (fields: any) => void;
  handleBack: () => void;
  onFieldsReady: (ready: boolean) => void;
  handleCloseModalConfirmation: () => void;
  handleCloseModalRequestExist: () => void;
  handleGoToExists: () => void;
  handleQuitModalConfirmation: () => void;
  showModalConfirmation: boolean;
  showModalRequestExist: boolean;
  errorCRM: boolean;
  setErrorCRM: (show: boolean) => void;
  error: string;
  goBackToProcedures: () => void;
}

const RetirementOfPeriodRegisterView: React.FC<
  RetirementOfPeriodRegisterViewProps
> = ({
  procedureSelectedInfo,
  isLoading,
  handleSubmit,
  handleBack,
  onFieldsReady,
  handleCloseModalConfirmation,
  handleCloseModalRequestExist,
  handleGoToExists,
  handleQuitModalConfirmation,
  showModalConfirmation,
  showModalRequestExist,
  errorCRM,
  setErrorCRM,
  error,
  goBackToProcedures
}) => (
  <ContainerProcedure>
    <SubContainer style={{ marginBottom: 24 }}>
      <BackButton onClick={handleBack} />
    </SubContainer>
    {procedureSelectedInfo?.isLoading ? (
      <Spinner />
    ) : (
      <SubContainer>
        <ToggleHeader
          name={procedureSelectedInfo?.name}
          amount={procedureSelectedInfo?.amount}
          duration={procedureSelectedInfo?.duration}
          date={procedureSelectedInfo?.endDate}
          childContent={
            <Block customized gap="16px">
              <Block customized style={{ width: 'auto' }}>
                El retiro del periodo lectivo es un trámite voluntario que
                permite al alumno retirarse del ciclo académico actual.
              </Block>
              <Heading
                text="Consideraciones"
                level={3}
                color="var(--text-text02)"
                size={14}
                lineHeight={20}
                fontWeight="700"
                className=""
                align="flex-start"
                width="100%"
              />
              <Block
                customized
                padding="4px 0px 0px 16px"
                style={{ width: 'auto' }}
              >
                <ul style={{ listStyleType: 'disc' }}>
                  <li>El retiro no exonera el pago de cuotas vencidas.</li>
                  <li>
                    De aplicar la solicitud, solo se revierten las cuotas no
                    vencidas.
                  </li>
                  <li>
                    No recibirás calificaciones ni serás considerado repitente
                    en las asignaturas matriculadas.
                  </li>
                  <li>No estar en un proceso disciplinario.</li>
                </ul>
              </Block>
            </Block>
          }
        />
        <TextTitle title="Progreso" />
        <Block customized padding="28px 0px 45px 8px">
          <Step
            name={procedureSelectedInfo?.steps[0]?.name}
            order={procedureSelectedInfo?.steps[0]?.order}
            isCurrent
          >
            <RegisterForm
              options={procedureSelectedInfo?.reasons || []}
              availableTimeSlots={
                procedureSelectedInfo?.detail?.communicationRange || []
              }
              onFieldsReady={onFieldsReady}
              handleSubmit={handleSubmit}
            />
          </Step>
          <Step
            name={procedureSelectedInfo?.steps[1]?.name}
            order={procedureSelectedInfo?.steps[1]?.order}
            isLast
            disabled
          />
        </Block>
      </SubContainer>
    )}

    <Processing isOpen={isLoading} />

    <Modal
      show={showModalRequestExist}
      handleClose={handleCloseModalRequestExist}
    >
      <RequestExist handleClick={handleGoToExists} />
    </Modal>
    <Modal
      show={showModalConfirmation}
      handleClose={handleCloseModalConfirmation}
    >
      <ConfirmationQuit
        handleQuit={handleQuitModalConfirmation}
        handleCancel={handleCloseModalConfirmation}
      />
    </Modal>
    <Modal show={errorCRM} handleClose={() => setErrorCRM(false)}>
      <NotAvailable
        handleClick={goBackToProcedures}
        textInformation="¡Oh no!"
        subtitle={error}
      />
    </Modal>
  </ContainerProcedure>
);

export default RetirementOfPeriodRegisterView;
